import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'af-fraud-report-sign-dialog',
    standalone: false,
    templateUrl: './fraud-report-sign-dialog.component.html',
})
export class FraudReportSignDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<FraudReportSignDialogComponent>,
    ) {
    }
}
